import { useState } from 'react';
import { useServices } from '../lib/data.ts';
import { durLabel, moneyShort } from '../lib/format.ts';
import { BackHeader } from '../ui/Header.tsx';
import { Icon } from '../ui/Icon.tsx';
import { Skeleton } from '../ui/State.tsx';

const norm = (t: string) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Serviços e preços só para consultar ou mostrar à cliente: sem editar, sem sair da tela
export function Tabela() {
  const q = useServices();
  const [busca, setBusca] = useState('');
  const list = (q.data ?? []).filter((s) => s.active && (!busca.trim() || norm(`${s.name} ${s.category}`).includes(norm(busca.trim()))));
  const cats = [...new Set(list.map((s) => s.category || 'Outros'))];
  return (
    <div className="view-enter cp2"><BackHeader title="Serviços e preços" />
      <div className="cp2-body">
        <div className="search-in"><Icon name="search" /><input type="search" placeholder="Buscar procedimento" value={busca} onChange={(e) => setBusca(e.target.value)} aria-label="Buscar procedimento" /></div>
        {q.data === undefined && <Skeleton rows={5} />}
        {cats.map((c) => (
          <div key={c}>
            <p className="gl-title">{c}</p>
            <div className="gl">
              {list.filter((s) => (s.category || 'Outros') === c).map((x) => (
                <div key={x.id} className="gl-row tb-row">
                  <b>{x.name}<small>{durLabel(x.durationMin)}{x.description ? ` · ${x.description}` : ''}</small></b>
                  <em className="sv-price">{x.priceFrom ? 'a partir de ' : ''}{moneyShort(x.priceCents)}</em>
                </div>
              ))}
            </div>
          </div>
        ))}
        {q.data !== undefined && !list.length && <p className="m-hint">Nenhum procedimento com esse nome.</p>}
      </div>
    </div>
  );
}
